enum EnvironmentEnum {
  LOCAL = 'local',
  DEV = 'dev',
  QA = 'qa',
  STAGE = 'stage',
  PROD = 'prod',
  PR = 'pr',
}

type EnvironmentEnumType = `${EnvironmentEnum}`;

export const envSwitch = (envOptions: Record<EnvironmentEnum, string>, overrideEnv?: EnvironmentEnumType): string => (
  envOptions[overrideEnv ?? process.env.REACT_APP_DEPLOY_ENV as EnvironmentEnum]
);

export const CORTEX_URL = envSwitch({
  local: 'http://localhost:8000',
  dev: 'https://cortex.bighealthdev.com',
  qa: 'https://cortex.bighealthdev.com',
  pr: 'https://cortex.bighealthdev.com',
  stage: 'https://cortex.bighealthstage.com',
  prod: 'https://cortex.bighealth.com',
});

export const VAF_URL = envSwitch({
  local: 'https://vercel-auth-functions-lower.vercel.app',
  dev: 'https://vercel-auth-functions-lower.vercel.app',
  qa: 'https://vercel-auth-functions-lower.vercel.app',
  pr: 'https://vercel-auth-functions-lower.vercel.app',
  stage: 'https://vercel-auth-functions-stage.vercel.app',
  prod: 'https://vercel-auth-functions-prod.vercel.app',
});

export const SUPABASE_URL = envSwitch({
  local: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  dev: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  qa: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  pr: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  stage: 'https://ngxdbhvvxledqxykuwpr.supabase.co',
  prod: 'https://evwudmabosoioeqpdbii.supabase.co',
});

export const ENTROPY_URL = envSwitch({
  local: 'https://entropy-lower.vercel.app',
  dev: 'https://entropy-lower.vercel.app',
  qa: 'https://entropy-lower.vercel.app',
  pr: 'https://entropy-lower.vercel.app',
  stage: 'https://entropy-stage.vercel.app',
  prod: 'https://entropy-prod.vercel.app',
});

/**
 * Where the Canopy web app is served from, per environment — the origin only, with no path.
 *
 * Empty where no web app is deployed yet. That is a real state, not a placeholder: the web
 * client is a Beta, and an environment without one must hand no session to a web address at
 * all. Every reader treats empty as "no web handoff here" and falls back to the manual
 * screen, so filling these in is the single step that turns web handoff on for an
 * environment.
 *
 * Kept here with CORTEX_URL and the rest rather than in an environment variable, because the
 * build injects only REACT_APP_DEPLOY_ENV and every other per-environment address in this app
 * is a literal in this file. A second variable would also have to be threaded through the
 * shared deploy action, and a value that silently failed to arrive would disable web handoff
 * with nothing in the build output to say so.
 *
 * The matching setting on the auth service is its CANOPY_WEB_ORIGIN, which has no envSwitch of
 * its own to live in. The two must name the same origin: this one decides whether CAP hands a
 * session to that address, and the auth service's decides whether the address may go into a
 * magic-link email at all.
 */
export const CANOPY_WEB_ORIGIN = envSwitch({
  local: 'http://localhost:3000',
  dev: 'https://canopy-sleepio-next.vercel.app',
  qa: 'https://canopy-sleepio-next.vercel.app',
  pr: 'https://canopy-sleepio-next.vercel.app',
  stage: '',
  prod: '',
});
